<template>
  <div data-scroll-name="gallery">
    <section class="my-20">
      <Container className="lg:flex gap-24">
        <div class="flex-none w-full lg:w-80 mb-8 text-center lg:text-left lg:mb-0">
          <SectionHeader>Gallery</SectionHeader>
          <div class="mt-5" v-if="photosLimit !== 0 && getAllPhotos.length > photosLimit">
            <button
              @click="loadMorePhotos"
              class="py-2.5 px-5 cursor-pointer text-white"
              :class="{
                'bg-primary-color': !getPrimaryColor,
                [`bg-[${getPrimaryColor}]`]: getPrimaryColor
              }"
            >
              Load All Photos
            </button>
          </div>
        </div>

        <div class="flex-1">
          <masonry
            :cols="{default: 2, 480: 1}"
            :gutter="16"
          >
            <div
              v-for="(photo, index) in photos"
              :key="photo.md"
              class="group relative cursor-pointer mb-4"
              @click="selectPhoto(index)"
            >
              <img
                :src=photo.md
                class="transition-opacity duration-300"
              />
              <div
                class="absolute inset-0 flex justify-center items-center opacity-0 transition-opacity duration-200 group-hover:opacity-85"
                :class="{
                  'bg-primary-color': !getPrimaryColor,
                  [`bg-[${getPrimaryColor}]`]: getPrimaryColor
                }"
              >
                <div>
                  <FontAwesomeIcon icon="eye" class="h-8! w-8! text-white" />
                </div>
              </div>
            </div>
          </masonry>
        </div>
      </Container>

      <HMTLightbox
        :show="isLightbox"
        :index="photoIndex"
        :items="getAllPhotos"
        @onClose="toggleLightbox"
      />
    </section>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  import SectionHeader from '../../components/SectionHeader';
  import HMTLightbox from '@/shared/components/Lightbox';
  import gaMixin from '@/shared/mixins/ga';
  import deviceMixin from '@/shared/mixins/device';
  import Container from '../../components/Container';

  export default {
    name: 'Gallery',
    mixins: [
      gaMixin,
      deviceMixin
    ],
    components: {
      SectionHeader,
      HMTLightbox,
      Container,
    },
    data () {
      return {
        photoIndex: 0,
        photosLimit: 4,
        isLightbox: false
      }
    },
    computed: {
      ...mapGetters('tour', ['getAllPhotos', 'getPrimaryColor']),
      photos () {
        if (this.photosLimit > 0) {
          return this.getAllPhotos.slice(0, this.photosLimit);
        }

        return this.getAllPhotos;
      }
    },
    methods: {
      selectPhoto (photoIndex) {
        this.photoIndex = photoIndex;

        this.toggleLightbox();
        this.sendEventGA('Gallery', `Image ${photoIndex + 1}`, 'Selected');
      },
      loadMorePhotos () {
        this.photosLimit = 0
      },
      toggleLightbox () {
        this.isLightbox = !this.isLightbox;
      }
    }
  };
</script>
